import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import { Employee } from '~/types';
import { cleanupFormValues } from '~/utils';
import EmployeeForm from './EmployeeForm';
import { employees } from '~/routes';
import { FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { useEmployeesEdit } from '~/hooks/employees';

interface EmployeeEditProps {
  initialValues: Employee;
}

const EmployeeEdit: FC<EmployeeEditProps> = (props) => {
  const { initialValues } = props;
  const [t] = useTranslation('employees');
  const dt = (key: string): string => t(`translation:${key}`);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate, isLoading } = useEmployeesEdit(initialValues, handleClose);

  const onFinish = (values: Employee) => {
    const cleanValues = cleanupFormValues({ ...initialValues, ...values });
    if (isEmpty(cleanValues.document)) {
      delete cleanValues.document;
    }
    mutate({
      id: initialValues.id as string,
      body: cleanValues,
    });
  };

  const hasAccess = usePermissions('business.employee.update');
  if (!hasAccess) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {dt('edit')}
      </Button>
      <FormDrawer
        name={employees}
        onFinish={onFinish}
        loading={isLoading}
        title={t('editEmployee')}
        onClose={handleClose}
        visible={open}
      >
        <EmployeeForm name={employees} initialValues={initialValues} edit />
      </FormDrawer>
    </>
  );
};

export default EmployeeEdit;
